import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { logisticsApi } from '../api/logistics-api';
import type { AssignCarrierRequest, LogisticsQuoteRequest } from './types';

export const logisticsKeys = {
  all: ['logistics'] as const,
  shipment: (orderId: string) => [...logisticsKeys.all, 'shipment', orderId] as const,
  carriers: () => [...logisticsKeys.all, 'carriers'] as const,
};

export function useShipmentQuery(orderId: string | undefined) {
  return useQuery({
    queryKey: logisticsKeys.shipment(orderId ?? ''),
    queryFn: () => logisticsApi.getShipmentByOrder(orderId!),
    enabled: Boolean(orderId),
    staleTime: 30_000,
  });
}

export function useCarriersQuery(enabled = true) {
  return useQuery({
    queryKey: logisticsKeys.carriers(),
    queryFn: () => logisticsApi.listCarriers(),
    enabled,
    staleTime: 5 * 60_000,
  });
}

export function useAssignCarrierMutation(shipmentId: string, orderId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: AssignCarrierRequest) => logisticsApi.assignCarrier(shipmentId, body),
    onSuccess: (data) => qc.setQueryData(logisticsKeys.shipment(orderId), data),
  });
}

export function useLogisticsQuoteMutation() {
  return useMutation({
    mutationFn: (body: LogisticsQuoteRequest) => logisticsApi.quote(body),
  });
}
